var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"xp-client-heading"},[_c('div',[_c('div',{staticClass:"xp-client-eyebrow"},[_vm._v("XPROJECT · 工作空间")]),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }